import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomEvent = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.96699 4.2169C6.25618 4.50611 6.25618 4.975 5.96699 5.26421L2.78786 8.44334L5.96699 11.6225C6.25618 11.9117 6.25618 12.3806 5.96699 12.6698C5.67779 12.959 5.20889 12.959 4.91968 12.6698L1.2169 8.96699C0.927699 8.6778 0.927699 8.20888 1.2169 7.91969L4.91968 4.2169C5.20889 3.9277 5.67779 3.9277 5.96699 4.2169ZM9.36303 4.2169C9.65222 3.9277 10.1211 3.9277 10.4103 4.2169L14.1131 7.91969C14.4023 8.20888 14.4023 8.6778 14.1131 8.96699L10.4103 12.6698C10.1211 12.959 9.65222 12.959 9.36303 12.6698C9.07384 12.3806 9.07384 11.9117 9.36303 11.6225L12.5422 8.44334L9.36303 5.26421C9.07384 4.975 9.07384 4.50611 9.36303 4.2169Z",
		fill: "#1F4C5C"
	})]
});
const ForwardRef = forwardRef(SvgCustomEvent);
export { ForwardRef as ReactComponent };
